<template>
  <div>
    <portal target-el="#filter">
      <PrimaryFilter :key="filterUpdate"
                     :menuOptions="Menu"
                     @generateReport="drawer=true"
                     :buttonsList="getReportButtons"
                     :preSearchedParams="searchedParams"
                     :searchParameters="reportSearchConstants"
                     :noSearchFilter="false"
                     :enableSearchPopup="enableSearchPopup"
                     :searchText="'Search reports'"
                     @searchByParameter="searchByParameter"/>
    </portal>
    <div v-if="isPageLoading"></div>
    <Row v-else :gutter="22" class="mt-m20">
      <Col :span="12" class="bg-blue-light1 pt-20" style="height: calc(100vh - 110px);
            overflow: auto;">
        <Row :gutter="16">
          <Col :span="12">
            <div v-for="report in group1Reports" class="cards" v-bind:key="report.id">
              <Radio v-model="radio" :label="report.id" @change="radioChange">
                <h4 class="d-flex">
                  <div class="break-word wp-w90 radio-left-label">{{ report.name }}</div>
                  <span class="f-right text-center" style="margin-top:-6px;">
                            <Tooltip placement="bottom">
                                  <div slot="content" class="checkbox_instruction tooltipcontent">
                                    <div class="tooltipcontent_header">REPORT HEADERS</div>
                                      <ul class="flexgroup">
                                        <li style="display: block" v-for="(header,index) in report.reportHeaders"
                                            v-bind:key='index'>
                                          {{ header }}
                                        </li>
                                      </ul>
                                    </div>
                              <span class="text-xs">{{ report.reportHeaders.length }}
                                <small style="font-size:8px;line-height:8px;"
                                       class="d-block text-grey-medium10">header</small></span>
                            </Tooltip>
                            </span>
                </h4>
                <p v-if="report.description">{{ report.description }}</p>
              </Radio>
            </div>
          </Col>
          <Col :span="12">
            <div v-for="report in group2Reports" class="cards" v-bind:key="report.id">
              <Radio v-model="radio" :label="report.id" @change="radioChange">
                <h4 class="d-flex">
                  <div class="break-word wp-w90 radio-left-label">{{ report.name }}</div>
                  <span class="f-right text-center" style="margin-top:-6px;">
                            <Tooltip placement="bottom">
                                  <div slot="content" class="checkbox_instruction tooltipcontent">
                                    <div class="tooltipcontent_header">REPORT HEADERS</div>
                                      <ul class="flexgroup">
                                        <li v-for="(header,index) in report.reportHeaders" v-bind:key='index'>
                                          {{ header }}
                                        </li>
                                      </ul>
                                    </div>
                                <span class="text-xs">{{ report.reportHeaders.length }}
                                <small style="font-size:8px;line-height:8px;"
                                       class="d-block text-grey-medium10">header</small></span>
                            </Tooltip>
                            </span>
                </h4>
                <p v-if="report.description">{{ report.description }}</p>
              </Radio>
            </div>
          </Col>
        </Row>
      </Col>

      <Col :span="12" style="border-left: 1px solid #E2EAEC;">
        <div class="justify-content d-flex align-items-center">
          <h4 class="text-brand text-capitalize text-sm mb-10">Queued Reports</h4>
          <div class="refresh-btn">
            <svgicon name="icon-fetch" width="10" height="10" @click="reloadReportList" />
          </div>
        </div>
        <div style="height: calc(100vh - 160px);
            overflow: auto;">
          <div class="bg-white">
            <Table
              class="table-striped bordered mt-10"
              :data="triggeredReports"
              :row-class-name="'is-disabled-text'"
              :stripe="true"
            >
              <TableColumn prop="no" label="S.no" width="50">
              </TableColumn>
              <TableColumn prop="name" label="Report Name | Report Filter" width="190">
                <template slot-scope="scope">
                  <div class="">
                    <p class="m-0">{{ scope.row.name }}</p>
                    <Tooltip placement="bottom">
                      <div slot="content" class="checkbox_instruction tooltipcontent flexgroup"
                           v-for="(value, key) in scope.row.arguments" :key="key">
                        <div class="tooltipcontent_header">{{ key }}</div>
                        <ul v-if="isArray(value)" class="flexgroup mt-15">
                          <li v-for="(item,index) in value.slice(0, 5)" v-bind:key='index'>
                            {{ item }}
                          </li>
                          <li v-if="value.length > 5">
                            +{{ value.length - 5 }} more
                          </li>
                        </ul>
                        <ul v-else>
                          <li>
                            {{ value }}
                          </li>
                        </ul>
                      </div>
                      <small v-if="scope.row.arguments" style="font-size:10px;line-height:10px;"
                             class="py-5 d-block text-grey-medium10">
                        {{ Object.keys(scope.row.arguments).length }} filters</small>
                    </Tooltip>
                  </div>
                </template>
              </TableColumn>
              <TableColumn prop="status" label="Status" width="90">
                <template slot-scope="scope">
                    <span class="text-xs tag-badge bg bg-primary text-capitalize"
                          :class="reportStatus[scope.row.status]">
                    <strong>{{ reportStatusType[scope.row.status] }}</strong>
                    </span>
                </template>
              </TableColumn>
              <TableColumn prop="generate" label="generate time | generated by" sortable width="220">
                <template slot-scope="scope">
                  <div>
                    <p class="m-0">{{ scope.row.createdAt }}</p>
                    <small>{{ scope.row.createdBy }}</small>
                  </div>
                </template>
              </TableColumn>
              <TableColumn prop="icon">
                <template slot-scope="scope">
                  <div class="f-right" :class="{ 'pointer': scope.row.status === 2}" v-if="downloadStatus[scope.row.status]">
                    <svgicon :name="downloadStatus[scope.row.status]" width="14" height="14" :original="true"
                             @click="scope.row.status === 2 ? downloadReport(scope.row) : null"/>
                  </div>
                </template>
              </TableColumn>
            </Table>
          </div>
        </div>
      </Col>
    </Row>

    <Drawer
      direction="rtl"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :with-header="false"
      class="default-drawer dark">
      <div class="default-slider slider-dark">
        <div class="drawer-header px-15">
          Generate Report
          <div class="header-item ml-auto">
            <Button
              type="secondary"
              size="mini"
              @click="closeGenerateReportTab"
            >Cancel
            </Button>
            <Button type="primary" size="mini" :disabled="disableGenerateReportBtn" @click="generateReport"
            >Generate
            </Button>
          </div>

        </div>
        <div class="px-20">
          <div class="flex-container">
            <span style="color: #EEF2F4; font-size: 1.2rem;" class="m-0 text-sm text-capitalize text-grey_lighter10">Depot</span>
            <div class="f-right popover-dropdown">
              <div @click="openPopover" class="input-container">
                <Input
                  :placeholder="checkedOptions.length ? '' : 'Select'"
                  class="tag"
                  readonly>
                  <template slot="suffix">
                    <div class="tag-container">
                      <Tag
                        v-if="checkedOptions.length"
                        closable
                        @close="handleClose(checkedOptions[0])"
                        class="selected-tag">
                        <span class="tag-text">{{ combinedDepotMap.get(checkedOptions[0]) }}</span>
                      </Tag>
                      <Tag v-if="checkedOptions.length > 1" class="count-tag">
                        + {{ checkedOptions.length - 1 }}
                      </Tag>
                      <svgicon name="arrow" width="10" height="10" :original="false"/>
                    </div>
                  </template>
                </Input>
              </div>
              <Popover
                placement="bottom"
                trigger="manual"
                v-model="popoverVisible"
                :append-to-body="true">
                <div class="popover-header">
                  <ul>
                    <li class="text-brand text-sm text-bold d-inline">Type</li>
                    <li class="pointer text-brand text-sm text-bold d-inline popover-header-option"
                        @click="tabpanel='associated'" :class="[tabpanel === 'associated' ? 'active' : 'bg-grey-lighter-rgba']">
                      Associated Depots
                    </li>
                    <li class="pointer text-brand text-sm text-bold d-inline popover-header-option"
                        @click="tabpanel='other'"
                        :class="[tabpanel === 'other' ? 'active' : 'bg-grey-lighter-rgba']">Other Depots
                    </li>
                  </ul>
                </div>
                <div v-if="tabpanel === 'associated'" class="tab-body">
                <div>
                    <Checkbox
                      :value="isAllAssociatedSelected"
                      @change="toggleSelectAllAssociated">
                      Select All
                    </Checkbox>
                  </div>
                  <div v-for="option in depots" :key="option.id">
                    <Checkbox
                      v-model="checkedOptions"
                      :key="option.id"
                      :label="option.id"
                      @change="filterChange">
                      {{ option.name }}
                    </Checkbox>
                  </div>
                </div>
                <div v-else-if="tabpanel === 'other' && otherDepots.length" class="py-10">
                  <div>
                      <Checkbox
                        :value="isAllOthersSelected"
                        @change="toggleSelectAllOthers">
                        Select All
                      </Checkbox>
                    </div>
                  <div v-for="option in otherDepots" :key="option.id">
                    <Checkbox
                      v-model="checkedOptions"
                      :key="option.id"
                      :label="option.id"
                      @change="filterChange">
                      {{ option.name }}
                    </Checkbox>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
          <ul class="drawer-list list-flex">
            <li class="mb-5">
              <label> {{ selectedReport.isDispatchDateBased ? 'Dispatched Date' : 'Created Date' }} </label>
              <div class="list-content">
                <DatePicker
                  v-model="dateFilter"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  size="mini"
                  popper-class="popper-dark popper-icon"
                  class="datepicker-dark daterange no-bg"
                  :clearable="false"
                  :picker-options="datePickerOptions"
                  @change="filterChange"
                />
              </div>
            </li>
            <div style="width: 100%;text-align: right; font-size: 1rem;padding-top: 5px;">
              <span v-if="dateFilterError" class="d-block text-alert">{{ $getErr("DATE_FILTER_ERROR") }}</span>
              <span v-if="dateMaxRangeError" class="d-block text-alert">{{ getDateFilterErrorMesssage() }}</span>
              <span v-if="depotFilterError" class="d-block text-alert">{{$getErr("DEPOT_FILTER_ERROR")}}</span>
              <span v-if="selectedReport" class="d-block text-grey-medium" style="font-size: 0.8rem;">
                Select any {{ getDefaultFilterDateRange() === -1 ? '45' : getDefaultFilterDateRange() }}-days range within last 24 months
              </span>
            </div>
          </ul>
        </div>

      </div>

    </Drawer>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { Menu, reportButtons, filters, reportStatusType } from '@/constants/reportConstants';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  components: {
    PrimaryFilter,
  },
  data() {
    return {
      combinedDepotMap: [],
      inputLabel: '',
      popoverVisible: false,
      tabpanel: 'associated',
      options: [
        { label: 'New York City' },
        { label: 'Los Angeles' },
        { label: 'Chicago' },
      ],
      checkedOptions: [],
      enableSearchPopup: true,
      singleDayReports: ['Optima Variance', 'Optima Variance Summary', 'Optima vs Dispatch Materials'],
      reportStatus: {
        2: 'bg-success',
        1: 'bg-purple-light',
        3: 'bg-danger',
        4: 'bg-orange-light',
      },
      reportStatusType,
      downloadStatus: {
        2: 'icon-download-xl',
        1: 'icon-time',
      },
      Menu,
      reportButtons,
      reports: [],
      filters,
      defaultDateRange: [moment().subtract(45, 'days').startOf('day').toString(), moment().endOf('day').toString()],
      disableGenerateReportBtn: false,
      isPageLoading: true,
      dateFilterError: false,
      dateMaxRangeError: false,
      depotFilterError: false,
      radio: null,
      selectedReportIndex: 0,
      dateFilter: [],
      selectedReport: {},
      filteredReports: [],
      queriedReports: [],
      group1Reports: [],
      group2Reports: [],
      filterUpdate: 0,
      reportSearchConstants: [
        {
          name: 'Report Name',
          query: 'name',
        },
        {
          name: 'Report Headers',
          query: 'headers',
        },
      ],
      searchedParams: {},
      drawer: false,
    };
  },
  async created() {
    this.reports = await this.$store.dispatch('report/reportsConfig');
    const combinedDepots = [...this.depots, ...this.otherDepots];
    this.combinedDepotMap = new Map(combinedDepots.map(item => [item.id, item.name]));
    await this.$store.dispatch('report/getReportList');
    this.filteredReports = this.reports.filter(report =>
      (report.feature ? this.$hasFeature(report.feature) : true) &&
      (report.permission ? this.$hasPermission(report.permission) : true));
    this.loadSearchFromSession();
    this.setDefaultFilters();
    this.loadData();
    this.filterUpdate += 1;
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      otherDepots: 'app/getOtherDepots',
      configurations: 'app/configurations',
      SearchParams: 'report/getSearchParams',
      triggeredReports: 'report/getTriggeredReports',
    }),
    isAllAssociatedSelected() {
      return this.depots.length > 0 && this.depots.every(depot => this.checkedOptions.includes(depot.id));
    },
    isAllOthersSelected() {
      return this.otherDepots.length > 0 && this.otherDepots.every(depot => this.checkedOptions.includes(depot.id));
    },
    getReportButtons() {
      const buttonList = this.reportButtons;
      const buttonIndex = buttonList.findIndex(button => button.name === 'Generate Report');
      if (this.selectedReportIndex === 0) {
        buttonList[buttonIndex].disabled = true;
      } else {
        buttonList[buttonIndex].disabled = false;
      }
      return buttonList;
    },
    datePickerOptions() {
      if (!this.selectedReport) {
        return {};
      }

      const currentDate = moment();
      const minDate = currentDate.clone().subtract(24, 'months').startOf('day').toDate();
      const maxDate = currentDate.endOf('day').toDate();

      return {
        disabledDate(date) {
          return date < minDate || date > maxDate;
        },
      };
    },
  },
  methods: {
    toggleSelectAllAssociated() {
      if (this.isAllAssociatedSelected) {
        // exclude the 0th index
        const associatedIds = this.depots.map(depot => depot.id);
        const firstDepotId = this.depots[0].id;
        this.checkedOptions = this.checkedOptions.filter(id => !associatedIds.includes(id) || id === firstDepotId);
      } else {
        const allAssociatedIds = this.depots.map(depot => depot.id);
        this.checkedOptions = [...new Set([...this.checkedOptions, ...allAssociatedIds])];
      }
      this.filterChange();
    },
    toggleSelectAllOthers() {
      if (this.isAllOthersSelected) {
        const otherIds = this.otherDepots.map(depot => depot.id);
        this.checkedOptions = this.checkedOptions.filter(id => !otherIds.includes(id));
      } else {
        const allOtherIds = this.otherDepots.map(depot => depot.id);
        this.checkedOptions = [...new Set([...this.checkedOptions, ...allOtherIds])];
      }
      this.filterChange();
    },
    openPopover() {
      this.popoverVisible = !this.popoverVisible;
    },
    handleClose(option) {
      const index = this.checkedOptions.indexOf(option);
      if (index >= 0) {
        this.checkedOptions.splice(index, 1);
      }
      this.filterChange();
    },
    searchByParameter(params) {
      const validFilter = this.validateFilter(params);
      this.searchedParams = validFilter ? params : {};
      const filterState = validFilter ? params : {};
      this.$store.commit('report/SET_SEARCH_PARAMS', filterState);
      this.saveSearchToSession();
      this.loadData();
    },
    validateFilter(params) {
      const paramKeys = params ? Object.keys(params) : [];
      paramKeys.forEach((attr) => {
        if (!params[attr]) {
          delete params[attr];
        }
      });
      return params;
    },
    saveSearchToSession() {
      if (this.searchedParams) {
        const sessionSearch = JSON.stringify(this.searchedParams);
        localStorage.setItem(`${this.$route.name.toLowerCase()}-search-popup`, sessionSearch);
      }
    },
    // To load pre-searched data from local during refresh
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name.toLowerCase()}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
      const validFilter = this.validateFilter(sessionSearchParams);
      const filterState = validFilter ? sessionSearchParams : null;
      this.$store.commit('report/SET_SEARCH_PARAMS', filterState);
    },
    loadData() {
      try {
        this.isLoading = true;
        const searchParams = this.SearchParams;
        const searchKeys = this.SearchParams ? Object.keys(searchParams) : [];
        if (searchKeys.length) {
          this.queriedReports = searchKeys.reduce((acc, key) => {
            acc = acc.length ? acc : this.filteredReports;
            acc = acc.filter((_report) => {
              if (key === 'headers') {
                return _report.reportHeaders && _report.reportHeaders.some(_item =>
                  _item.toLowerCase() === (searchParams[key]
                    && searchParams[key].toLowerCase()));
              }
              return _report[key] && _report[key].toLowerCase().includes(searchParams[key]
                && searchParams[key].toLowerCase());
            });
            return acc;
          }, []);
          const halfLength = Math.round(this.queriedReports.length / 2);
          this.group1Reports = this.queriedReports.slice(0, halfLength);
          this.group2Reports = this.queriedReports.slice(halfLength);
        } else {
          const halfLength = Math.round(this.filteredReports.length / 2);
          this.group1Reports = this.filteredReports.slice(0, halfLength);
          this.group2Reports = this.filteredReports.slice(halfLength);
        }
        this.isPageLoading = false;
      } catch (e) {
        console.log('error', e);
      }
    },
    radioChange() {
      this.selectedReportIndex = this.radio;
      this.selectedReport = this.filteredReports
        .find(_report => _report.id === this.selectedReportIndex);
      this.disableDepotFilter = this.selectedReport && this.selectedReport.group.includes('3');
      if (this.selectedReport
        && this.singleDayReports.includes(this.selectedReport.name)) {
        this.dateFilter = this.singleDayDateRange;
      }
      const defaultFilterDateRange = this.getDefaultFilterDateRange();
      if (defaultFilterDateRange === -1) {
        this.dateFilter = this.defaultDateRange;
        return;
      }
      const endDate = moment().endOf('day');
      const startDate = moment().subtract(defaultFilterDateRange, 'days').startOf('day');

      this.dateFilter = [startDate.toString(), endDate.toString()];
      this.disableGenerateReportBtn = false;
      this.filterChange();
    },
    setDefaultFilters() {
      this.selectedReportIndex = 0;
      this.checkedOptions = [];
      this.checkedOptions.push(this.depots[0].id);
      this.dateFilter = this.defaultDateRange;
    },
    filterChange() {
      const dateRange = this.dateFilter;
      this.depotFilterError = false;
      this.dateFilterError = false;
      this.dateMaxRangeError = false;
      this.disableGenerateReportBtn = false;
      if (this.selectedReport
        && this.singleDayReports.includes(this.selectedReport.name)
        && dateRange[0].toString() !== dateRange[1].toString()) {
        this.dateFilterError = true;
      }
      if (this.checkedOptions.length <= 0) {
        this.depotFilterError = true;
        this.disableGenerateReportBtn = true;
      }
      const fromDate = moment(dateRange[0]);
      const toDate = moment(dateRange[1]);
      const defaultFilterDateRange = this.getDefaultFilterDateRange();
      if (defaultFilterDateRange !== -1) {
        const maxAllowedDays = defaultFilterDateRange;
        const selectedDays = toDate.diff(fromDate, 'days');

        if (selectedDays > maxAllowedDays) {
          this.dateMaxRangeError = true;
          this.disableGenerateReportBtn = true;
        }
      } else {
        const selectedDays = toDate.diff(fromDate, 'days');

        if (selectedDays > 366) {
          this.dateMaxRangeError = true;
          this.disableGenerateReportBtn = true;
        }
      }
    },
    getDateFilterErrorMesssage() {
      const defaultFilterDateRange = this.getDefaultFilterDateRange();
      if (defaultFilterDateRange === -1) {
        return 'Date range cannot exceed 12 months';
      }
      return `Date range cannot exceed ${defaultFilterDateRange} days`;
    },
    closeGenerateReportTab() {
      this.drawer = false;
      this.dateMaxRangeError = false;
      this.disableGenerateReportBtn = false;
    },
    getDefaultFilterDateRange() {
      // Get default_date_range_to_filter from the selected report configuration
      if (this.selectedReport && this.selectedReport.default_date_range_to_filter) {
        return this.selectedReport.default_date_range_to_filter;
      }

      return -1;
    },
    async generateReport() {
      const payload = {
        depot_id: this.checkedOptions.join(','),
        start: moment(this.dateFilter[0]).toISOString(),
        end: moment(this.dateFilter[1]).toISOString(),
      };
      const result = await this.$store.dispatch(`report/${this.selectedReport.emitMethod}`, {
        params: payload,
        report: this.selectedReport,
      });
      console.log(result);
      if (!(result && result.status >= 400)) {
        this.$successMessage({
          message: this.$getSuccess('REPORT_GENERATE'),
        });
        this.resetToDefaults();
      } else {
        this.resetToDefaults();
        const errMessage = result.data.message;
        this.$errorMessage({ message: errMessage || this.$getErr(result.status.toString()) });
      }
      await this.reloadReportList();
    },
    async reloadReportList() {
      await this.$store.dispatch('report/getReportList');
    },
    resetToDefaults() {
      this.isPageLoading = true;
      this.drawer = false;
      this.radio = null;
      this.dateFilter = this.defaultDateRange;
      this.disableGenerateReportBtn = true;
      this.setDefaultFilters();
      this.isPageLoading = false;
    },
    isArray(value) {
      return Array.isArray(value);
    },
    downloadReport(report) {
      const url = report.s3_link;
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$errorMessage({ message: 'Something went wrong - Download link not available' });
      }
    },
  },
};
</script>

<style lang="scss">
.flexgroup {
  flex-direction: row;
}
.popper-icon {
  .el-icon-d-arrow-right:before {
    content: "\E613" !important;
  }

  .el-icon-arrow-right:before {
    content: "\E604" !important;
  }

  .el-icon-d-arrow-left:before {
    content: "\E610" !important;
  }

  .el-icon-arrow-left:before {
    content: "\E600" !important;
  }
}

.tab-body{
  padding: 0 10px;
  height:  calc(100vh - 200px);
  overflow-y: auto;
}

.refresh-btn{
  cursor: pointer;
  position: relative;
  margin-left: auto;
  background-color:#fff;
  border-radius:2px;
  padding: 8px 10px;
  border: 1px solid #EFEFEF;
}
</style>
